import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { SubpageNavbar } from '../components/SubpageNavbar';
import { Footer } from '../components/Footer';
export function AboutPage() {
  const [showEnergyCert, setShowEnergyCert] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-base-cream font-body text-base-dark flex flex-col" data-id="element-267">
      <SubpageNavbar currentPage="o-projektu" data-id="element-268" />

      {/* Energy Certificate Lightbox */}
      <AnimatePresence data-id="element-269">
        {showEnergyCert && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4 cursor-pointer" onClick={() => setShowEnergyCert(false)} data-id="element-270">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="relative max-w-3xl max-h-[90vh] w-full" onClick={e => e.stopPropagation()} data-id="element-271">
              <button onClick={() => setShowEnergyCert(false)} className="absolute -top-3 -right-3 z-10 bg-white rounded-full p-1.5 shadow-lg hover:bg-gray-100 transition-colors" data-id="element-272">
                <XIcon className="w-5 h-5 text-base-dark" data-id="element-273" />
              </button>
              <img src="https://cdn.magicpatterns.com/uploads/fQCYxsvoEWRX9mELM1hQRM/image.png" alt="Průkaz energetické náročnosti budovy – detail" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-274" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      <main className="flex-grow pt-24 pb-20" data-id="element-275">
        <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-276">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-277">
            <h1 className="font-heading md:text-5xl lg:text-6xl text-primary mb-12 text-center text-[48px]" data-id="element-278">
              O projektu
            </h1>

            <div className="space-y-12 text-lg text-base-gray leading-relaxed" data-id="element-279">
              {/* Widescreen hero image - gallery image #15, cropped to cut sky and grass */}
              <div className="w-full aspect-[21/9] rounded-xl overflow-hidden shadow-lg mb-4" data-id="element-280">
                <img src="https://cdn.magicpatterns.com/uploads/bwjXJdQQRFAcrtLM73zcm5/xx9.png" alt="Pohled z ulice na budovu" className="w-full h-full object-cover object-center" data-id="element-281" />
              </div>

              <section data-id="element-282">
                <h2 className="font-heading text-2xl md:text-3xl text-primary mb-4" data-id="element-283">
                  Nová generace bydlení
                </h2>
                <p data-id="element-284">
                  Polyfunkční dům u sv. Václava v Dolních Jirčanech představuje
                  moderní přístup k navrhování bytových staveb s důrazem na
                  technologickou kvalitu, energetickou efektivitu a dlouhodobou
                  udržitelnost provozu. Projekt kombinuje pokročilé stavební
                  konstrukce, efektivní technické systémy a promyšlené
                  dispoziční řešení bytů. Ve standardním vybavení bytu je
                  samozřejmostí klimatizace a dokonce rekuperační systém, který
                  zajišťuje neustále čerstvé ovzduší v bytě při zavřených oknech
                  při parametrech minimálně 30m3/h/osobu vyměněného vzduchu. V
                  zimě tedy nevyhazujete peníze oknem při větrání. V létě naopak
                  nepouštíte vedro dovnitř a čerstvý vzduch se částečně
                  ochlazuje o vypouštěný vzduch. Rekuperace zajišťuje i řízení
                  vlhkosti!
                </p>
              </section>

              <section data-id="element-285">
                <h2 className="font-heading text-2xl md:text-3xl text-primary mb-4" data-id="element-286">
                  Energetická náročnost a provozní efektivita
                </h2>
                <div className="flex gap-5 items-start" data-id="element-287">
                  <p className="flex-1" data-id="element-288">
                    Budova splňuje požadavky na výstavbu nových budov dle platné
                    legislativy a dosahuje energetické třídy A. Celková dodaná
                    energie činí cca 111,67 kWh/m² ročně, přičemž neobnovitelná
                    primární energie pouze 24,4 kWh/m² ročně. Významná část
                    energie (více než 75 %) je pokryta z obnovitelných zdrojů
                    prostřednictvím tepelných čerpadel a dalších technologií. Ve
                    své kategorii se jedná o unikátní stavbu nejen v rámci ČR,
                    ale i Evropy, co se týká právě energetické náročnosti.
                  </p>
                  <button onClick={() => setShowEnergyCert(true)} className="flex-shrink-0 w-28 md:w-36 rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 border border-primary/10 hover:border-primary/30 cursor-pointer group" title="Zobrazit průkaz energetické náročnosti" data-id="element-289">
                    <img src="https://cdn.magicpatterns.com/uploads/fQCYxsvoEWRX9mELM1hQRM/image.png" alt="Průkaz energetické náročnosti budovy" className="w-full h-auto group-hover:scale-105 transition-transform duration-300" data-id="element-290" />
                  </button>
                </div>
              </section>

              <section data-id="element-291">
                <h2 className="font-heading text-2xl md:text-3xl text-primary mb-4" data-id="element-292">
                  Konstrukční řešení
                </h2>
                <p data-id="element-293">
                  Nosná konstrukce objektu je tvořena železobetonovým systémem s
                  důrazem na optimalizaci tepelně-technických vlastností obálky
                  budovy. Obvodové stěny jsou zatepleny minerální izolací o
                  tloušťce až 200 mm, střešní konstrukce až 400 mm. Průměrný
                  součinitel prostupu tepla budovy dosahuje hodnoty 0,24 W/m²K,
                  což je lepší než referenční požadavek.
                </p>
              </section>

              <section data-id="element-294">
                <h2 className="font-heading text-2xl md:text-3xl text-primary mb-4" data-id="element-295">
                  Technické systémy budovy
                </h2>
                <p data-id="element-296">
                  Vytápění je řešeno kaskádou tepelných čerpadel vzduch–voda s
                  vysokou účinností (COP až 4,0), doplněných bivalentním
                  elektrokotlem pro špičkové zatížení. Příprava teplé vody je
                  kombinovaná – centrální systém s tepelným čerpadlem a
                  akumulací doplněný lokálními ohřívači. Větrání je zajištěno
                  lokálními rekuperačními jednotkami se zpětným získáváním
                  tepla.
                </p>
              </section>

              <section data-id="element-297">
                <h2 className="font-heading text-2xl md:text-3xl text-primary mb-4" data-id="element-298">
                  Energetický koncept
                </h2>
                <p data-id="element-299">
                  Projekt je navržen s důrazem na maximální využití energie
                  okolního prostředí. Tepelná čerpadla pokrývají většinu potřeby
                  tepla i teplé vody, čímž výrazně snižují závislost na
                  externích zdrojích energie. Budova využívá energeticky úsporné
                  LED osvětlení a připravenost na další optimalizaci spotřeby.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer data-id="element-300" />
    </div>;
}